import { TextInput } from '@octano/global-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { SectionTitle } from '../../../../components/text';
import { useValidations } from '../../../../hooks/useValidations';
import { CurriculumValues } from '../../../../types/CurriculumTypes';
import { formatToOnlyPositiveIntegers } from '../../../../utils/currency';

const CurriculumFormContentSies = () => {
  const { control } = useFormContext<CurriculumValues>();

  const prefix = 'studyPlans.curriculum';
  const { t } = useTranslation();

  const { rulesPatternDecimal } = useValidations();

  return (
    <Row>
      <Col xs={12} md={6}>
        <SectionTitle text={t(`${prefix}.siesTitle`)} />
      </Col>
      <Col xs={12} className="curriculum-sies pt-3">
        <Row>
          <Col xs={12} md={4} className="pb-3">
            <TextInput
              tooltip={t(`${prefix}.studyPlanDurationSemestersTooltip`)}
              label={t(`${prefix}.studyPlanDurationSemesters`)}
              name="studyPlanDurationSemesters"
              control={control}
              placeholder="0"
              rules={{
                pattern: rulesPatternDecimal,
              }}
              formatter={formatToOnlyPositiveIntegers}
            />
          </Col>
          <Col xs={12} md={4} className="pb-3">
            <TextInput
              tooltip={t(`${prefix}.graduationDurationSemestersTooltip`)}
              label={t(`${prefix}.graduationDurationSemesters`)}
              name="graduationDurationSemesters"
              control={control}
              placeholder="0"
              rules={{
                pattern: rulesPatternDecimal,
              }}
              formatter={formatToOnlyPositiveIntegers}
            />
          </Col>
          <Col xs={12} md={4} className="pb-3">
            <TextInput
              tooltip={t(`${prefix}.totalDurationSemestersTooltip`)}
              label={t(`${prefix}.totalDurationSemesters`)}
              name="totalDurationSemesters"
              control={control}
              placeholder="0"
              rules={{
                pattern: rulesPatternDecimal,
              }}
              formatter={formatToOnlyPositiveIntegers}
            />
          </Col>
          <Col xs={12} md={4} className="pb-3"></Col>
        </Row>
      </Col>
    </Row>
  );
};

export default CurriculumFormContentSies;
